/*
 * SPDX-FileCopyrightText: 2021 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { getGlobalState, store } from '..'
// import type { LoginUserInfo } from '../../api/me/types'
import type { UpdateCommentAction, AppendCommentPositionAction, SetCommentPositionAction, UpdateCommentButtonAction, UpdateCommentBoxAction, UpdateCommentButtonPositionAction, UpdateSelectedRangeAction, UpdateCommentPositionOnChangeAction, UpdatePrevTextAndSelectionAction, UpdateCommentListAction, UpdateCommentRepliesAction, UpdateCommentCountAction } from './types'
import { CommentActionType } from './types'

// export const createComment = (state: any): void => {
//   const action: CreateCommentAction = {
//     type: CommentActionType.CREATE_COMMENT,
//     state
//   }
//   store.dispatch(action)
// }

export const setCommentPosition = (state: any): void => {
  const action: SetCommentPositionAction = {
    type: CommentActionType.SET_COMMENTS_POSITION,
    state
  }
  store.dispatch(action)
}

export const appendCommentPosition = (state: any): void => {
  const action: AppendCommentPositionAction = {
    type: CommentActionType.APPEND_COMMENT_POSITION,
    state
  }
  store.dispatch(action)
}

export const updateComment = (state: any): void => {
  const action: UpdateCommentAction = {
    type: CommentActionType.UPDATE_COMMENT,
    state
  }
  store.dispatch(action)
}

export const updateCommentReplies = (state: any): void => {
  const action: UpdateCommentRepliesAction = {
    type: CommentActionType.UPDATE_COMMENT_REPLIES,
    state
  }
  store.dispatch(action)
}

export const updateCommentButton = (state: any): void => {
  const action: UpdateCommentButtonAction = {
    type: CommentActionType.UPDATE_SHOW_COMMENT_BUTTON,
    state
  }
  store.dispatch(action)
}

export const updateCommentBox = (hidden: boolean): void => {
  const action: UpdateCommentBoxAction = {
    type: CommentActionType.UPDATE_SHOW_COMMENT_BOX,
    state: hidden
  }
  store.dispatch(action)
}

export const updateCommentList = (hidden: boolean): void => {
  const action: UpdateCommentListAction = {
    type: CommentActionType.UPDATE_SHOW_COMMENT_LIST,
    state: hidden,
  }
  store.dispatch(action)
}

export const updateCommentButtonPosition = ({ left, top, width }): void => {
  const action: UpdateCommentButtonPositionAction = {
    type: CommentActionType.UPDATE_COMMENT_BUTTON_POSITION,
    state: {
      left, top, width
    }
  }
  store.dispatch(action)
}

export const updateTextSelection = (state: any): void => {
  const action: UpdateSelectedRangeAction = {
    type: CommentActionType.UPDATE_SELECTED_RANGE,
    state
  }
  store.dispatch(action)
}

export const updatePrevTextAndSelection = (selection: any, plain: string): void => {
  const action: UpdatePrevTextAndSelectionAction = {
    type: CommentActionType.UPDATE_PREV_TEXT_AND_SELECTION,
    state: { selection, plain }
  }
  store.dispatch(action)
}

const isInteractingWithComment = (commentPosition, prevSelection) => {
  const start = commentPosition.attributes.anchor
  const end = commentPosition.attributes.anchor + commentPosition.attributes.length

  if(prevSelection >= start && prevSelection <= end){
    return [true, prevSelection == start ? true : false];
  }
  return [false, false]
}

export const updateCommentPositionOnChange = (): void => {
  const prevMarkdown = getGlobalState().commentsData.prevMarkdown;
  const prevSelection = getGlobalState().commentsData.prevSelection;
  const updatedMarkdown = getGlobalState().noteDetails.markdownContent.plain;
  const commentPositions = getGlobalState().commentsData.positions;

  const diffInLength = updatedMarkdown.length - prevMarkdown.length;
  const { from: prevSelectionFrom } = prevSelection;
  let updatedPositions = commentPositions;

  if (diffInLength > 0) {
    updatedPositions = commentPositions.map(commentPosition => {
      if (isInteractingWithComment(commentPosition, prevSelectionFrom)[0]) {
        return {
          ...commentPosition,
          attributes: {
            ...commentPosition.attributes,
            length: commentPosition.attributes.length + 1
          }
        }
      }
      if (commentPosition.attributes.anchor > prevSelectionFrom) {
        return {
          ...commentPosition,
          attributes: {
            ...commentPosition.attributes,
            anchor: commentPosition.attributes.anchor + 1
          }
        }
      }
      return commentPosition;
    })
  }
  if (diffInLength < 0) {
    updatedPositions = commentPositions.map(commentPosition => {
      const [isIntract, isStart] = isInteractingWithComment(commentPosition, prevSelectionFrom)
      if (isIntract) {
        return {
          ...commentPosition,
          attributes: {
            ...commentPosition.attributes,
            anchor: isStart ? commentPosition.attributes.anchor - 1 : commentPosition.attributes.anchor,
            length: isStart ? commentPosition.attributes.length : commentPosition.attributes.length - 1
          }
        }
      }
      if (commentPosition.attributes.anchor > prevSelectionFrom) {
        return {
          ...commentPosition,
          attributes: {
            ...commentPosition.attributes,
            anchor: commentPosition.attributes.anchor - 1
          }
        }
      }
      return commentPosition;
    })
  }

  const action: UpdateCommentPositionOnChangeAction = {
    type: CommentActionType.UPDATE_COMMENT_POSITION_ON_CHANGE,
    state: updatedPositions
  }
  store.dispatch(action)
}

export const setCommentCount = (count: number) => {
  const action: UpdateCommentCountAction = {
    type: CommentActionType.UPDATE_COMMENT_COUNT,
    count,
  }
  store.dispatch(action)
}
